import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import { history } from 'nallian-shared-ui/lib/config/history';
import createCommunityRoleService from '../../services/communityRoles/createCommunityRoleService';
import CommunityRoleForm from './CommunityRoleForm';

const EMPTY_COMMUNITY_ROLE = {};

const NewCommunityRole = ({ open, dispatchCreateCommunityRolePost, createCommunityRoleFetch }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const handleSubmit = useCallback(
    body =>
      dispatchCreateCommunityRolePost(
        id,
        body.tag,
        pickBy(pick(body, ['alias']), v => v !== null && v !== undefined && v !== ''),
        () => history.push(`/communities/edit/${id}`),
        t
      ),
    [dispatchCreateCommunityRolePost, id, t]
  );

  if (!open) return null;

  return (
    <CommunityRoleForm
      header={t('newCommunityRole')}
      onSubmit={handleSubmit}
      submitProcessing={createCommunityRoleFetch.pending}
      returnRoute={`/communities/edit/${id}`}
      cancelRoute={`/communities/edit/${id}`}
      data={EMPTY_COMMUNITY_ROLE}
    />
  );
};

NewCommunityRole.propTypes = {
  dispatchCreateCommunityRolePost: PropTypes.func.isRequired,
  createCommunityRoleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewCommunityRole.defaultProps = { open: false };

export default createCommunityRoleService(NewCommunityRole);
